import {
  List,
  ListItemButton,
  ListSubheader,
  styled,
  useTheme,
} from '@mui/material';

import { Fragment, useState } from 'react';

import { DropdownIcon } from '@app-velocity/icons';

import { Box, ContextMenu } from '@app-velocity/ui';

import { SingleTeam } from './components/SingleTeam/SingleTeam';
import { useWorkspaceSwitcherData } from '../../hooks/useWorkspaceSwitcherData';
import { SingleMenuElement } from './components/SingleMenuElement';

import { SingleTeamSkeleton } from './components/SingleTeamSkeleton';
import { NewTeamButton } from './components/NewTeamButton';

const StyledTeamSwitcher = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  svg: {
    stroke: 'var(--icon-icon-secondary-color)',
  },
}));

const StyledOrganizationName = styled(ListSubheader)(({ theme }) => ({
  background: 'transparent',
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  lineHeight: 1.5,
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(6),
}));

export const TeamSwitcher = () => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  const { teams, activeTeam, isLoading } = useWorkspaceSwitcherData();

  return (
    <StyledTeamSwitcher>
      <List disablePadding sx={{ height: '100%' }}>
        <StyledListItemButton
          sx={{ height: '100%' }}
          onClick={(e) => setAnchor(e.currentTarget)}
          data-testid="active-workspace-button"
        >
          {isLoading || !activeTeam ? (
            <SingleTeamSkeleton />
          ) : (
            <SingleTeam team={activeTeam} />
          )}
          <DropdownIcon />
        </StyledListItemButton>
      </List>

      {teams && (
        <ContextMenu
          data-testid="workspaces-menu"
          width={theme.constants.sidebarWidth - 16}
          anchor={anchor}
          closeMenu={() => setAnchor(null)}
        >
          {Object.keys(teams.byOrganization).map((organizationId) => (
            <Fragment key={organizationId}>
              <StyledOrganizationName>
                {teams.byOrganization[organizationId].organizationName}
              </StyledOrganizationName>
              {teams.byOrganization[organizationId].teams.map((team) => (
                <SingleMenuElement team={team} key={team.teamId} />
              ))}
              <NewTeamButton organizationId={organizationId} />
              <ContextMenu.Divider />
            </Fragment>
          ))}
          {teams.noOrganization.map((team) => (
            <SingleMenuElement team={team} key={team.teamId} />
          ))}
        </ContextMenu>
      )}
    </StyledTeamSwitcher>
  );
};
